import EmailsCards from '../../components/Emails/EmailsCards';
import ListingPage from '../../components/ListingPage';

const EmailsPage = () => {
  return (
    <ListingPage
      createRestrictionKey="emailsCreate"
      entityType="email"
      useStats={true}
      filterBy="name"
      Cards={EmailsCards}
    />
  );
};

export default EmailsPage;
